/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefInvitationData } from '../../models/api-def-invitation-data';

export interface OrganizationsGetInvitationById$Params {

/**
 * The ID of the organization
 */
  organizationId: string;

/**
 * The ID of the invitation to retrieve
 */
  invitationId: string;

/**
 * The token associated with the invitation
 */
  token?: string;
}

export function organizationsGetInvitationById(http: HttpClient, rootUrl: string, params: OrganizationsGetInvitationById$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * The name of the organization
 */
'organizationName'?: string;
'invitation'?: ApiDefInvitationData;
}>> {
  const rb = new RequestBuilder(rootUrl, organizationsGetInvitationById.PATH, 'get');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('invitationId', params.invitationId, {});
    rb.query('token', params.token, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      
      /**
       * The name of the organization
       */
      'organizationName'?: string;
      'invitation'?: ApiDefInvitationData;
      }>;
    })
  );
}

organizationsGetInvitationById.PATH = '/organizations/{organizationId}/users/invitations/{invitationId}';
